import { headingText } from './headingText';
import React, { useState, useEffect } from 'react';
import { doc, updateDoc, increment } from 'firebase/firestore';
import { markBlogPostAsRead } from './blogReadState';
import ContentImage from './ContentImage';
import Modal from './Modal';
export default function SinglePostPage({ post, onBack, db, appId }) {
    const [open, setOpen] = useState(false);
    useEffect(() => {
        markBlogPostAsRead(post.id);
        const path = `/artifacts/${appId}/public/data/blogPosts`;
        updateDoc(doc(db, path, post.id), { viewCount: increment(1) }).catch(() => {});
    }, [db, appId, post.id]);
    return <article className="article-page max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <button type="button" onClick={onBack} className="text-link">← Zpět na blog</button>
        <h1 className="article-title">{headingText(post.title)}</h1><p className="editorial-date">{post.date} · Tomáš Číhal</p>
        {post.image && <button type="button" className="article-image-button" onClick={() => setOpen(true)} aria-label="Zvětšit fotografii článku"><ContentImage src={post.image} alt={post.title} className="article-image" /></button>}
        <div className="article-body" style={{ whiteSpace: 'pre-wrap' }}>{post.content}</div>
        {open && <Modal label={post.title} onClose={() => setOpen(false)}><ContentImage src={post.image} alt={post.title} className="modal-image" /></Modal>}
    </article>;
}
